const getContactInfo = ()=>{
    return{
        POSTAL_CODE:process.env.POSTAL_CODE,
        PHONE_NUMBER:process.env.NEXT_PUBLIC_PHONE,
        EMAIL:process.env.EMAIL,
        GEO_LOCATION:process.env.GEO_LOCATION,
    }
}

export default getContactInfo